<script>
import { mapState } from 'vuex'
import { Payment } from '@/enums/Payment'
import secureLs from '@/helpers/localStorage'
import CreditBalance from '@/components/credit/CreditBalance.vue'
// import CreditCharge from '@/components/credit/CreditCharge.vue'
import CreditPayment from '@/components/credit/CreditPayment.vue'
import CheckoutPayPal from '@/components/checkout/paypal/CheckoutPayPal.vue'
export default {
  components: {
    CreditBalance,
    // CreditCharge,
    CreditPayment,
    CheckoutPayPal
  },
  mixins: [secureLs],
  props: {
    price: { type: Object },
    orderId: { type: Number },
    disabled: { type: Boolean },
    nextStep: { type: Function },
    loadingPrice: { type: Boolean }
  },
  data: vm => ({
    loading: false,
    error: false,
    paid: false,
    panel: vm.disabled ? -1 : 0 // default active-panel (-1 = non selected, 0 = first selected)
  }),
  computed: {
    ...mapState({
      credit: state => state.credit
    }),
    hasCreditAccountPermission() {
      return this.$permissions.hasCreditAccount
    },
    isDisabled() {
      return this.price.totalGrossPrice > this.credit.creditBalance
    },
    paymentOptions() {
      let options = {}
      options.paypal = true
      options.credit = this.hasCreditAccountPermission
      options.count = Object.keys(options).filter(
        option => options[option]
      ).length
      return options
    },
    hasSinglePaymentOption() {
      return this.paymentOptions.count <= 1
    }
  },
  watch: {
    disabled(newValue) {
      this.panel = !newValue ? 0 : -1
    },
    panel(newValue) {
      this.$emit('onPaymentSelected', Payment[Payment.getKey(newValue)])
    }
  },
  methods: {
    submit() {
      this.loading = true
      this.error = false
      this.$ordersService
        .getPaymentUrl({
          orderId: this.orderId,
          returnUrl: `${window.config.VUE_APP_BASE_URL}/upload/` + this.orderId
        })
        .then(response => {
          // redirect to payment-service-hoster
          window.location = response.redirectUrl
        })
        .catch(() => {
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    onPaid(paid) {
      this.paid = paid
      this.nextStep()
    }
  }
}
</script>
<template>
  <div>
    <v-alert v-if="error" type="error">
      {{ $t('component.checkout.checkoutNextStep.loading.error') }}
    </v-alert>
    <v-expansion-panels
      v-model="panel"
      focusable
      :disabled="disabled"
      class="pb-6">
      <v-expansion-panel
        v-if="paymentOptions.paypal"
        :readonly="hasSinglePaymentOption"
        :disabled="hasSinglePaymentOption">
        <v-expansion-panel-header>
          <v-radio
            id="checkoutPaypal"
            :label="$t('component.checkout.checkoutNextStep.payment.paypal')"
            :off-icon="panel === 0 ? '$radioOn' : '$radioOff'"
          ></v-radio>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pt-6">
          <v-row v-if="price.fee">
            <v-col>
              <v-alert outlined>
                <currency :value="price.fee.value">
                  <template #default="slotProps">
                  {{ $t('component.checkout.checkoutNextStep.payment.paypal.fees', {
                      '{FEE_VALUE}': slotProps.currencyValue }) }}
                </template>
                </currency>
              </v-alert>
            </v-col>
          </v-row>
          <v-row v-if="!paid">
            <v-col cols="12" xl="6" class="mx-auto">
              <CheckoutPayPal :order-id="orderId" @onApproved="onPaid" />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="paymentOptions.credit">
        <v-expansion-panel-header>
          <v-radio
            id="paymentCredit"
            :label="$t('component.checkout.checkoutNextStep.payment.credit')"
            :off-icon="panel === 1 ? '$radioOn' : '$radioOff'"
          ></v-radio>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pt-6">
          <v-row>
            <v-col cols="12" xl="6" class="mx-auto">
              <h3 class="primary--text text-center mb-2">
                <CreditBalance />
              </h3>
              <CreditPayment
                v-if="!isDisabled"
                :order-id="orderId"
                :price="price"
                @onPayed="nextStep" />
<!--              <CreditCharge v-else />-->
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-row>
      <v-col class="text-center grey lighten-4 ml-3 mr-3">
        <v-skeleton-loader
          :loading="loadingPrice"
          height="94"
          type="article"
          transition="slide-x-transition" >
          <v-card elevation="0" class="transparent pa-0 ma-0">
            <v-alert v-if="error" type="error">
              {{ $t('component.checkout.checkoutNextStep.loading.error') }}
            </v-alert>
            <h1 class="headline primary--text">
              {{ $t('component.checkout.checkoutNextStep.only') }}
              <currency>{{ price.totalGrossPrice }}</currency>
            </h1>
            <span
              class="center-text"
              v-html="$t('component.checkout.checkoutNextStep.include.mwst', {
                  '{{price.totalTaxRate}}': price.totalTaxRate }) ">
            </span>
          </v-card>
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>